import React from 'react';
//import MapboxGL from '@mapbox/react-native-mapbox-gl';

const ANNOTATION_SIZE = 45;
import {
    PermissionsAndroid,
    View,
    Image,
    ScrollView,
    Dimensions,
    Text,
    Alert,
    TouchableOpacity,
    StyleSheet,
    Animated, FlatList, I18nManager, BackHandler, ActivityIndicator, ToastAndroid, Platform,
    Keyboard,
    KeyboardAvoidingView
} from "react-native";
import {moderateScale} from "../../../tools/Scaling";

const {width, height} = Dimensions.get('window');
import Colors from "../../../tools/Colors";

let container = null;
const isValidCoordinate = geometry => {
    if (!geometry) {
        return false;
    }
    return geometry.coordinates[0] !== 0 && geometry.coordinates[1] !== 0;
};
//import MapView from 'react-native-maps'; // remove PROVIDER_GOOGLE import if not using Google Maps

//import Geocoder from 'react-native-geocoding';
import axios from "axios";
import XMLParser from "react-xml-parser";
import {typeExport} from "../../../redux/store/type";
import HMTextView from "../../../customviews/HMTextView";
import HMTextInput from "../../../customviews/HMTextInput";
import i18n from "../../../I18n/i18n";
//import Modal from "react-native-modal";
import store from "../../../redux/store/index";
//import ParentScreen from "../../../../ParentScreen";
import * as NavigationService from "../../../redux/NavigationService";
import SpeechAndroid from 'react-native-android-voice-persian';
import {Tools} from "../../../tools/Tools";
import DialogLoadingCustomize from "../../../customviews/DialogLoadingCustomize";
import Popup from "../../../tools/mapLink/components/Popup";
import HMActionBarSatia from "../../../customviews/HMActionBarSatia";
import PathFile from "../../../assets/PathFile/index";
import HMMap from "../../../customviews/map/HMMap";
import HMAlert from "../../../customviews/HMAlert";
import HMIcon from "../../../customviews/HMIcon";


//Geocoder.init("AIzaSyBYeVVlRqu44-h_AAu2btjKF-6JNB9Xh3E");

class ShowMap extends React.Component {
    constructor(props) {
        super(props);
        container = this;
        // this._mapOptions = Object.keys(MapboxGL.StyleURL)
        //     .map(key => {
        //         return {
        //             label: key,
        //             data: MapboxGL.StyleURL[key],
        //         };
        //     })
        //     .sort(onSortOptions);

        let myLocation = props.navigation && props.route.params && props.route.params.myLocation;
        let my_possitiob = store.getState().reducerSplashGetAllData.Location;

        let lat = 0
        let long = 0
        if (!myLocation || Platform.OS === "web") {
            let center = typeExport._NameApp == "CloudTest" || typeExport._NameApp == "Cloud" ? store.getState().reducerSplashGetAllData?.City?.map?.center : null;

            lat = parseFloat(props.navigation && props.route.params && props.route.params.position && props.route.params && props.route.params.position.coords ? props.route.params.position.coords.latitude : (props.position ? props.position.coords.latitude : (my_possitiob ? my_possitiob.coords.latitude : (center ? parseFloat(center.latitude) : 0))));
            long = parseFloat(props.navigation && props.route.params && props.route.params.position && props.route.params && props.route.params.position.coords ? props.route.params.position.coords.longitude : (props.position ? props.position.coords.longitude : (my_possitiob ? my_possitiob.coords.longitude : (center ? parseFloat(center.longitude) : 0))));


        }
        this.state = {
            //   styleURL: this._mapOptions[0].data,
            reason: '',
            regionFeature: undefined,

            lat: lat,
            long: long,

            visibleModal: '',
            textInputSearch: '',
            ListSearch: [],

            loadingSearchMap: false,
            addressMap: null,
            autoFocus: true,

            // focusDescriptionInput:true,
            /*    lat: 0,
                long: 0,*/
        };


        this.onMapChange = this.onMapChange.bind(this);


        /*   this._tabOptions = [
               {label: 'Fly To', data: SF_OFFICE_COORDINATE},
               {
                   label: 'Fit Bounds',
                   data: [[-74.12641, 40.797968], [-74.143727, 40.772177]],
               },
               {label: 'Zoom To', data: 12},
           ];*/

        this.onRegionDidChange = this.onRegionDidChange.bind(this);
        this.onRegionWillChange = this.onRegionWillChange.bind(this);
        this.onOptionPress = this.onOptionPress.bind(this);
        this.onRegionIsChanging = this.onRegionIsChanging.bind(this);

        this.onFlyToPress = this.onFlyToPress.bind(this);
        this.onFlyToComplete = this.onFlyToComplete.bind(this);
        this.onUserLocationUpdate = this.onUserLocationUpdate.bind(this);


        //////////////////////


    }

    async componentWillMount() {
        let my_possitiob = store.getState().reducerSplashGetAllData.Location;
        let showPlace = this.props.navigation && this.props.route && this.props.route.params ? this.props.route.params.showPlace : this.props.showPlace;
        if (Platform.OS === "web") {

            if (showPlace) {
                //this.getAddressOfPoint(this.state.lat, this.state.long)
            }
            else if (my_possitiob) {
                this.props.changeLatLong ? this.props.changeLatLong(my_possitiob) : null
                global._regionFeature = my_possitiob;

                this.getAddressOfPoint(my_possitiob.coords.latitude, my_possitiob.coords.longitude)
            }

            if (this.state.lat)
                this.getAddressOfPoint(this.state.lat, this.state.long)

        }


        if ((this.props.myLocation || (this.props.navigation && this.props.route.params && this.props.route.params.myLocation))) {
            this.setState({isLoading: true},
                () => {
                    Tools.checkPermission(
                        "ShowMap",
                        this.props.route?.params?.item,
                        null,
                        this.goScreen,
                        this.stateError
                    )
                }
            )

        }

        global._regionFeature = null
        BackHandler.addEventListener('hardwareBackPress', this.handleBackButton);

        // Keyboard.dismiss();

        // if (typeExport.IS_ANDROID) {
        //     const isGranted = await MapboxGL.requestAndroidLocationPermissions();
        //     // this.setState({
        //     //     isAndroidPermissionGranted: isGranted,
        //     //     isFetchingAndroidPermission: false,
        //     // });
        // }
        //  this.InputTextSearch.focus();


    }

    componentDidMount() {
        Keyboard.dismiss();
        if (Platform.OS === "web") {
            //  console.log("this.map.mapRef.current", this.map.mapRef.current)
            //this.map.mapRef.current.leafletElement.locate({srtView: true})
        }
        this.setState({
            autoFocus: false
            // focusDescriptionInput:false
        })


        if (container["_InputTextSearch"])
            setTimeout(
                () => {
                    container["_InputTextSearch"].blur();
                }
                ,
                100
            );
    }

    componentWillUnmount() {
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackButton);

    }

    async _buttonClick() {
        try {
            //More Locales will be available upon release.
            var spokenText = await SpeechAndroid.startSpeech(i18n.t('constant.PleaseSaySomething'), SpeechAndroid.PERSIAN);
            this.setState({textInputSearch: spokenText}
                ,
                () => {
                    this.getJsonMap()
                }
            );
            // ToastAndroid.show(spokenText, ToastAndroid.LONG);
        } catch (error) {
            switch (error) {
                case SpeechAndroid.E_VOICE_CANCELLED:
                    ToastAndroid.show("Voice Recognizer cancelled", ToastAndroid.LONG);
                    break;
                case SpeechAndroid.E_NO_MATCH:
                    ToastAndroid.show("No match for what you said", ToastAndroid.LONG);
                    break;
                case SpeechAndroid.E_SERVER_ERROR:
                    ToastAndroid.show("Google Server Error", ToastAndroid.LONG);
                    break;
            }
        }
    }

    handleBackButton = () => {
        if (this.state.visibleModal === 'Modal') {
            this.setState({
                visibleModal: ''
            })
        } else {
            this.props.navigation.pop()
        }

        return true;
    };


    async onFlyToPress(long, lat) {
        // alert("dfgdf")
        //await this.map.mapRef.current.moveTo([ 49.66736778005486,34.08777640387088], 1000);
        /*      this.map.setCamera({
                  //  centerCoordinate: [49.66736778005486, 34.08777640387088],
                  centerCoordinate: [long, lat],
                  zoom: 16,
                  duration: 2000,
              })*/
        //  if ()
        if (Platform.OS === "web") {
            //this.map.leafletElement.flyTo(c, 20, this.getZoomPanOptions())

            setTimeout(
                () => {
                    this.map.mapRef.current.flyTo([lat, long], 18, {
                        animate: true,
                        duration: 1.5
                    })
                    //  this.map.mapRef.current.flyTo({
                    //      center: [lat, long],
                    //      zoom: 15,
                    //      speed: 5,
                    //  })


                    /*       //  let myLocation = store.getState().reducerSplashGetAllData.Location;
                           let myLocation = {coords: {latitude: 52.516272, longitude: 13.377722}};

                           this.map.mapRef.current.locate().on("locationfound", function (e) {

                               let l = Tools.getDistance(e.latlng, myLocation.coords)
                               console.log("locationfound", e.latlng, myLocation, l)
                               container.setState({
                                   lllllllll:e.latlng
                               })
                               if (l > 20) {

                               }
                               /!*   setPosition(e.latlng);
                                  map.flyTo(e.latlng, map.getZoom());
                                  const radius = e.accuracy;
                                  const circle = L.circle(e.latlng, radius);
                                  circle.addTo(map);
                                  setBbox(e.bounds.toBBoxString().split(","));*!/
                           });*/

                },
                500
            );
        }
        else {

            const camera = await this.map.mapRef.current.getCamera();

            camera.zoom = 17;
            camera.center.latitude = lat;
            camera.center.longitude = long;
            this.map.mapRef.current.animateCamera(camera, {duration: 2000});
        }

        // this.onFlyToComplete();
    }

    onFlyToComplete() {
        //HMAlert('Fly To Animation Completed', 'We did it!!!');
    }

    onMapChange(index, styleURL) {
        this.setState({styleURL});
    }

    async onOptionPress(optionIndex, optionData) {
        if (optionIndex === 0) {
            await this.map.mapRef.current.flyTo(optionData);
        } else if (optionIndex === 1) {
            await this.map.mapRef.current.fitBounds(optionData[0], optionData[1], 0, 200);
        } else if (optionIndex === 2) {
            await this.map.mapRef.current.zoomTo(optionData, 200);
        }
    }

    onRegionWillChange(regionFeature) {
        this.setState({reason: 'will change', regionFeature});
    }

    onRegionDidChange(regionFeature) {
        this.setState({reason: 'did change', regionFeature},
            () => {
            }
        );
    }

    onRegionIsChanging(regionFeature) {
        this.setState({reason: 'is changing', regionFeature});
    }


    onUserLocationUpdate(location) {
        this.setState({location: location});
    }

    /*   centerMap() {
           if (this.state.location) {
               this.map.mapRef.current.setCamera({
                   centerCoordinate: [this.state.location.coords.longitude, this.state.location.coords.latitude],
                   zoom: 16,
                   // duration: 2000,
                   mode: MapboxGL.CameraModes.Flight,
               });
           }
       }*/
    async centerMap() {
        if (this.state.location) {
            const camera = await this.map.getCamera();

            camera.zoom = 17;
            camera.center.latitude = this.state.location.coords.latitude;
            camera.center.longitude = this.state.location.coords.longitude;
            this.map.mapRef.current.animateCamera(camera, {duration: 2000});
            /*   this.map.mapRef.current.setCamera({
                    centerCoordinate: [this.state.location.coords.longitude, this.state.location.coords.latitude],
                    zoom: 16,
                    // duration: 2000,
                    mode: MapboxGL.CameraModes.Flight,
                });*/
        } else {
            //ParentScreen.ShowMessageBack(i18n.t('constant.Wait'))
        }

        /*
            if (global._regionUserChange) {
                const camera = await this.map.mapRef.current.getCamera();

                camera.zoom = 17;
                camera.center.latitude = global._regionUserChange.latitude;
                camera.center.longitude = global._regionUserChange.longitude;
                this.map.mapRef.current.animateCamera(camera, {duration: 2000});
            } else {
                ParentScreen.ShowMessageBack(i18n.t('constant.Wait'))
            }*/
    }

    _onMapReady = () => this.setState({marginBottom: 0})

    getJsonMap() {
        let {CenterLocation, Connection} = store.getState().reducerSplashGetAllData ? store.getState().reducerSplashGetAllData : {}
        if (Connection) {
            //  console.log("store.getState().reducerSplashGetAllData", store.getState().reducerSplashGetAllData)
            if (this.state.textInputSearch.length >= 2) {
                this.setState({loadingSearchMap: true});
                // let sr =
                //     '<?xml version="1.0" encoding="utf-8"?>' +
                //     '<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">' +
                //     '<soap:Body>' +
                //     `<GetAddress${typeExport._NameMap} xmlns="http://tempuri.org/">` +
                //     `<name>${this.state.textInputSearch}</name>` +
                //     `</GetAddress${typeExport._NameMap}>` +
                //     '</soap:Body>' +
                //     '</soap:Envelope>';
                //
                //
                // axios({
                //     method: 'post',
                //     url: typeExport.BASE_URL_Map,
                //     data: sr,
                //     headers: {
                //         'Content-Type': 'text/xml; charset=utf-8',
                //         // SOAPAction: 'http://schemas.facilinformatica.com.br/Facil.Credito.WsCred/IEmprestimo/CalcularPrevisaoDeParcelas'
                //     },
                //     timeout: typeExport._TIMEOUT,
                //
                // })
                // .then(response => {
                //         //  Keyboard.dismiss();
                //         var arr = (new XMLParser().parseFromString(response.data)).getElementsByTagName(`GetAddress${typeExport._NameMap}Result`);
                //         // var res = arr[0].value.replace(new RegExp(']"', "g"), "]").replace(new RegExp('"[', "g"), "[").trim()
                //         var res = JSON.parse(arr[0].value)
                //         this.setState({
                //             loadingSearchMap: false,
                //             ListSearch: res
                //         })
                //     }).catch((e) => {
                //         console.log(e)
                //         //  Keyboard.dismiss();
                //         this.setState({loadingSearchMap: false})
                //         alert(i18n.t('constant.retry'))
                //     })
                axios(
                    {
                        url: `https://api.neshan.org/v1/search?term=${typeExport._NameCity + " " + this.state.textInputSearch}&lat=${CenterLocation ? CenterLocation.latitude : null}&lng=${CenterLocation ? CenterLocation.longitude : null}`,
                        method: "GET",
                        headers: {
                            "Api-Key": "service.LuOT4aFuRkaVSDsE8WLNkgyhUtsRZ2UnG4mpBEQt",
                            // 'User-Agent': 'Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/69.0.3497.100 Safari/537.36',
                            "Content-Type": "application/json",
                        },
                        timeout: typeExport._TIMEOUT,
                    }
                )
                    .then(response => {
                        if (response.data.items) {
                            //  Keyboard.dismiss();
                            // var arr = (new XMLParser().parseFromString(response.data)).getElementsByTagName(`GetAddress${typeExport._NameMap}Result`);
                            // var res = arr[0].value.replace(new RegExp(']"', "g"), "]").replace(new RegExp('"[', "g"), "[").trim()
                            // var res = JSON.parse(arr[0].value)
                            this.setState({
                                loadingSearchMap: false,
                                ListSearch: response.data.items
                            })
                        }
                        else {
                            this.setState({loadingSearchMap: false})
                            alert(i18n.t('constant.retry'))
                        }

                    }).catch((e) => {
                    console.log(e)
                    //  Keyboard.dismiss();
                    this.setState({loadingSearchMap: false})
                    alert(i18n.t('constant.retry'))
                })

            }
            else {
                this.setState({
                    loadingSearchMap: false,
                    ListSearch: []
                })
            }
        } else {
            // ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
        }
    }

    getAddressOfPoint(lat, lon) {

        ////////////////////////////////////////////////////////
        // let sr =
        //     '<?xml version="1.0" encoding="utf-8"?>' +
        //     '<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">' +
        //     '<soap:Body>' +
        //     `<GetRegion${typeExport._NameMap} xmlns="http://tempuri.org/">` +
        //     `<lon>${lon}</lon>` +
        //     `<lat>${lat}</lat>` +
        //     `</GetRegion${typeExport._NameMap}>` +
        //     '</soap:Body>' +
        //     '</soap:Envelope>';
        const formData = new FormData();
        formData.append('_operation', typeExport._Registration);
        formData.append('mode', "GetRegion");
        formData.append('latitude', lat);
        formData.append('longitude', lon);
        // axios.post(typeExport._baseUrlSaina, formData, {
        //     headers: {
        //         "Content-Type": "application/json",
        //         // SOAPAction: 'http://schemas.facilinformatica.com.br/Facil.Credito.WsCred/IEmprestimo/CalcularPrevisaoDeParcelas'
        //     }
        // })
        /*  .then(response => {
                  var arr = (new XMLParser().parseFromString(response.data)).getElementsByTagName("GetAddressAhvazResult");
                  // var res = arr[0].value.replace(new RegExp(']"', "g"), "]").replace(new RegExp('"[', "g"), "[").trim()
                  var res = JSON.parse(arr[0].value)

              }
          )*/

        axios(
            {
                url: typeExport._baseUrlSaina,
                method: "post",
                headers: {
                    // "Api-Key": "service.WkSJqym8YdgRaUAOqFL3DDErhvP93vl5qsod151a",
                    // 'User-Agent': 'Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/69.0.3497.100 Safari/537.36',
                    "Content-Type": "application/json",
                },
                timeout: typeExport._TIMEOUT,
            }
        )
            .then(response => {

                let data = response.data;

                this.setState({
                    //    loadingSearchMap: false,
                    area: data.success && data.result && data.result.title ? data.result.title : (data.success ? "خارج از محدوده" : null)
                })
            }).catch((e) => {
            console.log("error", e)
            //  Keyboard.dismiss();
            //  this.setState({loadingSearchMap: false})
            //alert(i18n.t('constant.retry'))
        })
        ////////////////////////////////////////////////////////
        this.setState({
                addressMap: '',
                letAddressMarker: false,

                loadingAddressMarker: true,
            },
            () => {

                if (typeExport._NameApp === "Ahvaz" && Platform.OS !== "web") {
                    // axios(
                    //     {
                    //         //   url: `http://map.ahvaz.ir/api/v2/reverse?&lat=${lat}&lng=${lon}`,
                    //         url: (Platform.OS === "web" ? "https://app.iran137.com/proxymap.php" : "http://map.ahvaz.ir") + `/api/v2/reverse?lat=${lat}&lng=${lon}`,
                    //         method: "GET",
                    //         headers: {
                    //             "Api-Key": "service.WkSJqym8YdgRaUAOqFL3DDErhvP93vl5qsod151a",
                    //             // 'User-Agent': 'Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/69.0.3497.100 Safari/537.36',
                    //             "Content-Type": "application/json",
                    //         },
                    //         timeout: typeExport._TIMEOUT,
                    //     }
                    // )

                    axios(
                        {
                            // url: baseUrl + url + params,
                            url: (Platform.OS === "web" ? "https://app137.ahvaz.ir/proxymap.php" : "http://map.ahvaz.ir") + `/api/v2/reverse?lat=${lat}&lng=${lon}`,
                            //  url: "http://map.ahvaz.ir"+ `/api/v2/reverse?lat=${lat}&lng=${lon}`,
                            method: "GET",
                            //  params: params,
                            timeout: typeExport._TIMEOUT,
                            headers: {

                                'Content-Type': 'application/x-www-form-urlencoded',
                                "Api-Key": "service.WkSJqym8YdgRaUAOqFL3DDErhvP93vl5qsod151a",
                                // "Authorization": token,
                            },
                            /*      headers: {'X-Requested-With': 'XMLHttpRequest'},*/
                        }
                    )
                        .then(response => {

                            const address = response.data.formatted_address ? response.data.formatted_address.split(typeExport._NameCity + '،') : "";
                            let nameAddress = address && address.length >= 2 ? (address[1] && address[1].trim().length > 0 ? address[1] : (address.length >= 3 ? address[2] : "")) : (address && address.length == 1 ? address[0] : "");


                            this.props.onChangeText ? this.props.onChangeText(nameAddress) :
                                this.setState({textInputAddress: nameAddress}, () => {

                                })
                            this.setState({
                                addressMap: nameAddress,
                                textInputAddress: nameAddress,
                                letAddressMarker: response.data.route_name ? true : false,
                                loadingAddressMarker: false,
                            })

                        }).catch((e) => {
                        this.setState({loadingSearchMap: false, letAddressMarker: false, loadingAddressMarker: false,})
                        console.log("error", e);
                    })
                }
                else {
                    axios(
                        {
                            url: `https://api.neshan.org/v2/reverse?&lat=${lat}&lng=${lon}`,
                            method: "GET",
                            headers: {
                                "Api-Key": "service.LuOT4aFuRkaVSDsE8WLNkgyhUtsRZ2UnG4mpBEQt",
                                //'User-Agent': 'Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/69.0.3497.100 Safari/537.36',
                                "Content-Type": "application/json",
                            },
                            timeout: typeExport._TIMEOUT,
                        }
                    ).then(response => {

                        const address = response.data.formatted_address ? response.data.formatted_address.split(typeExport._NameCity + '،') : "";
                        let nameAddress = address && address.length >= 2 ? (address[1] && address[1].trim().length > 0 ? address[1] : (address.length >= 3 ? address[2] : "")) : (address && address.length == 1 ? address[0] : "");
                        this.props.onChangeText ? this.props.onChangeText(nameAddress) :
                            this.setState({textInputAddress: nameAddress}, () => {

                            })
                        // console.log("nameAddress", nameAddress, address);
                        // console.log("response", response);
                        this.setState({
                            addressMap: nameAddress,
                            textInputAddress: nameAddress,
                            letAddressMarker: response.data.route_name ? true : false,
                            loadingAddressMarker: false,
                        })

                    }).catch((e) => {
                        this.setState({loadingSearchMap: false, letAddressMarker: false, loadingAddressMarker: false,})
                        console.log("error", e);
                    })
                }


                /*     axios(
                         {
                             url: `http://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=18&addressdetails=1&&accept-language=${i18n.locale}`,
                             //    url: `http://nominatim.openstreetmap.org/reverse`,
                             //url: baseUrl + url + params + `&i=${page}`,
                             //  url: "http://samanebehnood.com",
                             method: "GET",
                             // params: {
                             //     'format': 'json',
                             //     'lat': this.props.route.params.position.lat,
                             //     'lon': this.props.route.params.position.long,
                             //     'zoom': 18,
                             //     'addressdetails': 1
                             // },
                             headers: {
                                 'User-Agent': 'Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/69.0.3497.100 Safari/537.36',
                                 "Content-Type": "application/json",
                                 // "Accept": "application/json",
                             },
                             timeout: typeExport._TIMEOUT,
                         }
                     ).then(response => {

                         //  let {city, neighbourhood,} = response.data.address

                         //  if (response.data.place_id)
                         const [name] = response.data.display_name.split(typeExport._NameCity + ',');
                         let [res_address] = name.split(typeExport._BakhshMarkazi);
                         let [res_area] = res_address.split(typeExport._Area);
                         let arr = res_area.split(',').reverse();

                         //  arr= arr.filter(Boolean)
                         arr = arr.filter(function (v) {
                             return v.trim() !== ''
                         })
                         let j = arr.join()
                         this.props.onChangeText ? this.props.onChangeText(j) :
                             this.setState({textInputAddress: j}, () => {

                             })
                         this.setState({
                             addressMap: j,
                             textInputAddress: j,
                             letAddressMarker: response.data.place_id ? true : false,
                             loadingAddressMarker: false,
                         })

                     }).catch((e) => {
                         this.setState({loadingSearchMap: false, letAddressMarker: false, loadingAddressMarker: false,})
                     })*/
            }
        )


    }

    _onRef = (property, view) => {
        this[property] = view
    }

    render() {

        let {checkSelectLocation, _setStateData} = this.props.navigation && this.props.route && this.props.route.params ? this.props.route.params : {}
        let item = this.props.navigation && this.props.route && this.props.route.params ? this.props.route.params.item : null
        let type = this.props.navigation && this.props.route && this.props.route.params ? this.props.route.params.type : (this.props.type ? this.props.type : null)
        let showPlace = this.props.navigation && this.props.route && this.props.route.params ? this.props.route.params.showPlace : null

        return (
            <View style={{flex: 1}}>
                {
                    this.props.navigation ?
                        <HMActionBarSatia
                            menu={store.getState().reducerSplashSatiaScreen.Account}
                            props={this.props} statusBarTransparent
                            text={!type ? i18n.t('constant.Map') : i18n.t('constant.LocationInformationMap')}
                            // text={this.state.lllllllll + " "}
                            //text={i18n.t('ListNews.title')}
                            // text={(item.name ? item.name : (item.title ? item.title : ''))}

                            back
                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />

                        :
                        null
                }

                <KeyboardAvoidingView
                    keyboardShouldPersistTaps={'handled'}
                    style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        flex: 1
                    }}>

                    <View
                        style={{
                            width: "100%",
                            //height:height-moderateScale(200),
                            height: "100%",
                            position: 'relative',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>

                        <HMMap
                            ref={ref => (this.map = ref)}
                            //   provider={PROVIDER_GOOGLE} // remove if not using Google Maps
                            onMapReady={this._onMapReady}
                            provider="google"

                            style={{
                                width: "100%",
                                //height:height-moderateScale(200),
                                height: "100%", marginBottom: this.state.marginBottom
                            }}

                            showsUserLocation={true}
                            //          followsUserLocation={true}
                            showsMyLocationButton={true}
                            showPlace={showPlace}
                            // onRegionChangeComplete={this.onRegionDidChange}
                            onRegionChangeComplete={(w) => {
                                // console.log("onRegionChangeComplete", w)
                                if (showPlace) {
                                    if (this.state.addressMap && this.state.addressMap.length > 0) {

                                    }
                                    else {
                                        this.props.changeLatLong ? this.props.changeLatLong(w) : null
                                        global._regionFeature = w;

                                        this.getAddressOfPoint(w.latitude, w.longitude)
                                    }

                                } else {
                                    this.props.changeLatLong ? this.props.changeLatLong(w) : null
                                    global._regionFeature = w;

                                    this.getAddressOfPoint(w.latitude, w.longitude)
                                }
                                // this.setState({
                                //     addressMap: ''
                                // })
                            }}

                            onUserLocationChange={(p) => {

                                // this.setState({
                                //     updateMyLocation:p.nativeEvent.coordinate
                                // })
                            }}
                            initialRegion={{
                                latitude: this.state.lat,
                                longitude: this.state.long,
                                latitudeDelta: 0.005,
                                longitudeDelta: 0.005,
                            }}


                            coordinate={{
                                latitude: this.state.lat,
                                longitude: this.state.long,
                                latitudeDelta: 0.015,
                                longitudeDelta: 0.0121,
                            }}
                        >
                            {/*   <MapView.UrlTile urlTemplate="https://c.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
                            {
                                showPlace ?
                                    <MapView.Marker coordinate={{
                                        latitude: this.state.lat,
                                        longitude: this.state.long,
                                        latitudeDelta: 0.015,
                                        longitudeDelta: 0.0121,
                                    }}/>
                                    : null
                            }*/}
                        </HMMap>

                        <View
                            style={{
                                bottom: 0,
                                width: '100%',
                                position: "absolute",
                                //  height:moderateScale(48),
//backgroundColor:'#ee46a5',
                                zIndex: 99
                            }}
                        >
                            {/*<HMTextView*/}
                            {/*// noFont={false}*/}
                            {/*type={'bold'}*/}
                            {/*text={this.state.addressMap}*/}
                            {/*numberOfLines={2}*/}
                            {/*style={{*/}
                            {/*fontSize: moderateScale(14),*/}
                            {/*// textAlign: 'right',*/}
                            {/*color: Colors.blackLight,*/}
                            {/*marginHorizontal: moderateScale(6),*/}
                            {/*marginVertical: moderateScale(1)*/}
                            {/*}}/>*/}

                            {
                                this.props.navigation ?
                                    <View
                                        style={{
                                            flex: 1,
                                            height: moderateScale(36),
                                            backgroundColor: Colors.colorPrimary,
                                            flexDirection: 'row',
                                            marginHorizontal: moderateScale(10),
                                            marginTop: moderateScale(6),
                                            borderRadius: moderateScale(14),
                                            borderColor: Colors.colorDark,
                                            borderWidth: moderateScale(1),

                                            marginBottom: moderateScale(6)
                                            // width:'100%'
                                        }}>

                                        <View
                                            style={{
                                                flex: .8,
                                                height: moderateScale(34),
                                                backgroundColor: Colors.white,
                                                borderRadius: moderateScale(14),
                                                flexDirection: 'row',
                                                paddingHorizontal: moderateScale(4),
                                                alignItems: 'center',

                                            }}>

                                            <View style={{width: moderateScale(5)}}/>


                                            {
                                                this.state.loadingAddressMarker ?
                                                    <ActivityIndicator color={Colors.colorPrimary}
                                                                       size={"large"}/>

                                                    :
                                                    <View style={{flexDirection: 'row'}}>
                                                        <HMTextView
                                                            numberOfLines={1}
                                                            onPress={() => HMAlert(
                                                                i18n.t('constant.address'),
                                                                this.state.addressMap,
                                                                [
                                                                    // {text: 'Ask me later', onPress: () => {}},
                                                                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                                    {
                                                                        text: i18n.t('constant.ok'), onPress: () => {
                                                                        }
                                                                    },
                                                                ],
                                                                {cancelable: true}
                                                            )}
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={this.state.addressMap}
                                                            //   text={"شبیسبسببیبلیبلل"}
                                                            type={"bold"} style={{
                                                            //textAlign: "center",
                                                            color: Colors.colorDarkText,
                                                            fontSize: moderateScale(12),
                                                            marginEnd: moderateScale(3)



                                                            // flex:1
                                                        }}/>
                                                    </View>
                                            }

                                        </View>
                                        <TouchableOpacity
                                            onPress={() => {
                                                if (checkSelectLocation) {
                                                    _setStateData({
                                                        R_latitude: global._regionFeature ? global._regionFeature.latitude : this.state.lat,
                                                        R_longitude: global._regionFeature ? global._regionFeature.longitude : this.state.long,
                                                        R_address: this.state.addressMap,
                                                    })
                                                    NavigationService.Pop();
                                                }
                                                else
                                                    this.nextScreen(item, type)
                                            }}
                                            style={{
                                                flex: .2,
                                                height: moderateScale(32),
                                                backgroundColor: Colors.colorPrimary,
                                                borderTopEndRadius: moderateScale(14),
                                                borderBottomEndRadius: moderateScale(14),
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>

                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={checkSelectLocation ? "تایید" : (type ? i18n.t('constant.next') : i18n.t('constant.Routing'))}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.white,
                                                    fontSize: moderateScale(11)

                                                }}/>
                                        </TouchableOpacity>
                                    </View>

                                    :

                                    <View
                                        style={{
                                            backgroundColor: Colors.white,
                                            width: '94%',
                                            alignSelf: 'center',
                                            marginBottom: moderateScale(5)
                                        }}>
                                        {
                                            this.state.loadingAddressMarker ?
                                                <ActivityIndicator color={Colors.colorPrimary}
                                                                   size={"large"}/>

                                                :
                                                <View style={{
                                                    flexDirection: 'row', width: '100%',
                                                    //height: moderateScale(45),
                                                    // backgroundColor: "#ee3c00",
                                                    alignItems: 'center'
                                                }}>

                                                    {
                                                        this.state.area ?
                                                            <View
                                                                style={{
                                                                    height: "100%",
                                                                    //  flexDirection: 'row', width: '100%', height: moderateScale(45),
                                                                    //    backgroundColor: "#3a5fee",
                                                                    flexDirection: 'row',
                                                                    //   marginStart:moderateScale(4),
                                                                    alignItems: 'center'

                                                                }}
                                                            >
                                                                <HMTextView
                                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                    text={this.state.area}
                                                                    type={"bold"}
                                                                    style={{
                                                                        textAlign: "center",
                                                                        color: Colors.colorDark,
                                                                        fontSize: moderateScale(12),
                                                                        marginHorizontal: moderateScale(4)

                                                                    }}/>
                                                                <View style={{
                                                                    width: moderateScale(1),
                                                                    height: "60%",
                                                                    backgroundColor: Colors.light2
                                                                }}/>

                                                            </View>
                                                            :
                                                            null
                                                    }
                                                    <View style={{flex: 1}}>
                                                        <HMTextInput

                                                            value={this.props.textInputAddress ? this.props.textInputAddress : this.state.textInputAddress}
                                                            onChangeText={
                                                                (text) => this.props.onChangeText ? this.props.onChangeText(text) :
                                                                    this.setState({textInputAddress: text}, () => {

                                                                    })}
                                                            // _height={40}
                                                            _multiline
                                                            //   focus={this.state.focusDescriptionInput}

                                                            // autoFocus
                                                            //  placeholder={i18n.t('constant.filter')}
                                                            placeholder={i18n.t('constant.AddressOfRequest')}
                                                            NoShowPlaceholder
                                                            //باتد_width={'80%'}
                                                            // icon={"md-person"}
                                                            style={{
                                                                fontSize: moderateScale(14),
                                                                //  marginHorizontal: moderateScale(10),
                                                                // marginTop: moderateScale(6)
                                                            }} underlineColorAndroid="transparent"/>
                                                    </View>
                                                    <View/>
                                                </View>
                                        }


                                    </View>
                            }


                            {/*<View style={{flex:.8}}>*/}

                            {/*</View>*/}
                            {/*<View style={{flex:.2}}>*/}
                            {/*<HMButton*/}
                            {/*text={type ? i18n.t('constant.next') : i18n.t('constant.Routing')}*/}
                            {/*textType={'bold'}*/}
                            {/*onPress={() => {*/}
                            {/*this.nextScreen(item, type)*/}

                            {/*}}*/}

                            {/*/>*/}
                            {/*</View>*/}

                        </View>
                        {
                            showPlace ?
                                null
                                :
                                <TouchableOpacity
                                    style={{
                                        width: moderateScale(90), height: moderateScale(90),

                                        //backgroundColor: "#ee0028",
                                        position: "absolute",
                                        zIndex: 99,

                                        // backgroundColor:"#c706ee",
                                        alignItems: "center",
                                    }}
                                    // onPress={() => {
                                    //     this.onFlyToPress()
                                    // }}
                                    onPress={() => {
                                        this.nextScreen(item, type)

                                    }}
                                >
                                    <Image source={PathFile.image.location}
                                           style={{
                                               width: moderateScale(45),
                                               height: moderateScale(45),
                                               // borderRadius: moderateScale(48)
                                           }}/>
                                </TouchableOpacity>
                        }

                        {
                            showPlace ? null
                                :
                                <View
                                    style={[
                                        //     Platform.OS === "web" ?
                                        //     {
                                        //     width: "96%",
                                        //     marginHorizontal: moderateScale(10)
                                        // } : {
                                        //     left: moderateScale(54),
                                        //     marginEnd: moderateScale(64),
                                        // },

                                        {

                                            position: "absolute",
                                            top: 0,
                                            width: "100%",
                                            // marginHorizontal:moderateScale(4),
                                            // marginRight: moderateScale(50),
                                            marginTop: moderateScale(4),
                                            // flex:1,

                                            //   backgroundColor: 'red',
                                            //marginRight:
                                            zIndex: 99,
                                            //  alignItems: "center"
                                        }]}
                                >
                                    <View style={{width: "100%", flexDirection: "row", alignItems: "center"}}>
                                        <HMIcon
                                            name={"my-location"}
                                            type={"MaterialIcons"}
                                            style={{
                                                fontSize: moderateScale(40),
                                                color: Colors.blue,
                                                marginHorizontal: moderateScale(4),
                                                //  marginTop: moderateScale(3)
                                            }}
                                            onPress={() => {
                                                Tools.checkPermission(
                                                    "ShowMap",
                                                    this.props.route?.params?.item,
                                                    null,
                                                    this.goScreen,
                                                    this.stateError
                                                )
                                            }}

                                        />

                                        <View
                                            style={{
                                                width: "80%",
                                                height: moderateScale(50),
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: Colors.white,
                                                borderRadius: moderateScale(6),
                                                //   marginStart: moderateScale(43),

                                            }}

                                            onPress={() => {
                                                this.setState({
                                                    visibleModal: 'Modal'
                                                })
                                            }}
                                        >


                                            <HMTextInput
                                                _ref={rf => this._onRef('_InputTextSearch', rf)}


                                                // _ref={'InputTextSearch'}

                                                //  ref={(r) => this.InputTextSearch = r}
                                                value={this.state.textInputSearch}
                                                //keyboardType="numeric"
                                                onChangeText={(text) => this.setState({textInputSearch: text}, () => {

                                                    this.getJsonMap()

                                                })}
                                                autoFocus={this.state.autoFocus}
                                                placeholder={i18n.t('constant.Search')}
                                                NoShowPlaceholder
                                                voice
                                                style={{
                                                    fontSize: moderateScale(14),
                                                }} underlineColorAndroid="transparent"

                                                styleRoot={{width: "100%"}}
                                            />

                                        </View>
                                    </View>
                                    <View
                                        style={{
                                            marginBottom: moderateScale(50),
                                            marginStart: moderateScale(38),
                                            width: "80%",
                                        }}>
                                        {
                                            !store.getState().reducerSplashGetAllData.Connection ?
                                                <View
                                                    style={{
                                                        flexDirection: 'row',
                                                        flex: 1,
                                                        alignItems: 'center',
                                                        backgroundColor: Colors.white
                                                    }}>
                                                    <HMTextView
                                                        // noFont={false}
                                                        text={i18n.t('constant.CheckYourInternet')}
                                                        numberOfLines={1}
                                                        style={{
                                                            fontSize: moderateScale(14),
                                                            // textAlign: 'right',
                                                            color: Colors.red,
                                                            marginHorizontal: moderateScale(6),
                                                            marginVertical: moderateScale(1)
                                                        }}/>
                                                </View>
                                                :

                                                <FlatList
                                                    keyboardShouldPersistTaps="handled"
                                                    // ItemSeparatorComponent={
                                                    //     <View style={{
                                                    //         width: '100%',
                                                    //         height: moderateScale(1),
                                                    //         backgroundColor: '#4f4f4f'
                                                    //     }}/>
                                                    // }
                                                    style={{
                                                        backgroundColor: Colors.white,
                                                        maxHeight: moderateScale(Platform.OS === "web" ? 450 : 300)

                                                    }}
                                                    ListEmptyComponent={() =>

                                                        <View
                                                            style={{}}>
                                                            {
                                                                this.state.loadingSearchMap ?
                                                                    <ActivityIndicator
                                                                        color={Colors.colorPrimary}
                                                                        size={"large"}/>
                                                                    :
                                                                    null

                                                            }
                                                        </View>
                                                    }
                                                    data={this.state.ListSearch}
                                                    renderItem={({item, index}) =>
                                                        <View style={{}}>
                                                            {
                                                                item.Address == "" ?
                                                                    null
                                                                    :
                                                                    <TouchableOpacity
                                                                        onPress={() => {
                                                                            this.setState({
                                                                                    addressMap: item.Address,
                                                                                    ListSearch: [],
                                                                                    textInputSearch: ''
                                                                                },
                                                                                () => {
                                                                                    Keyboard.dismiss();
                                                                                    this.hiddenModal();
                                                                                    //this.onFlyToPress(item.center[0], item.center[1]);
                                                                                    this.onFlyToPress(parseFloat(item.location ? item.location.x : item.Longtitude), parseFloat(item.location ? item.location.y : item.Latitude));
                                                                                })

                                                                        }
                                                                        }
                                                                        style={{
                                                                            width: "100%",
                                                                            //  flex: 1,
                                                                            marginHorizontal: moderateScale(10),
                                                                            alignItems: 'center'
                                                                            //  marginVertical: moderateScale(2),
                                                                            // padding: moderateScale(6)
                                                                        }}>

                                                                        <HMTextView
                                                                            // noFont={false}
                                                                            //  text={item.place_name}
                                                                            text={item.Address ? item.Address : item.title}
                                                                            numberOfLines={1}
                                                                            style={{
                                                                                fontSize: moderateScale(14),
                                                                                // textAlign: 'right',
                                                                                color: Colors.colorDark,
                                                                                marginVertical: moderateScale(1)
                                                                            }}/>
                                                                        <View style={{
                                                                            width: '90%',
                                                                            alignSelf: 'center',
                                                                            marginTop: moderateScale(2),
                                                                            marginBottom: moderateScale(4),
                                                                            height: moderateScale(1),
                                                                            backgroundColor: Colors.light
                                                                        }}/>
                                                                    </TouchableOpacity>
                                                            }


                                                        </View>
                                                    }

                                                />
                                        }
                                    </View>
                                </View>
                        }


                    </View>

                    <Popup
                        isVisible={this.state.isVisible}
                        onCancelPressed={() => this.setState({isVisible: false})}
                        onAppPressed={() => this.setState({isVisible: false})}
                        onBackButtonPressed={() => this.setState({isVisible: false})}
                        options={{
                            latitude: this.state.lat,
                            longitude: this.state.long,
                            // title: 'The White House',
                            dialogTitle: i18n.t('constant.Routing'),
                            dialogMessage: i18n.t('constant.SelectingDestination'),
                            cancelText: i18n.t('constant.Back')
                        }}
                        //  appTitles={{'Other': 'Other',}}
                    />
                    {
                        this.state.isLoading ?
                            <DialogLoadingCustomize/>
                            : null
                    }


                </KeyboardAvoidingView>


            </View>
        );
    }

    nextScreen(item, type) {
        type ?
            type === "layout" ?
                this.props.onclickPin()
                :
                NavigationService.navigateParams("SubmitRequestScreen",
                    {
                        item: JSON.stringify(item),
                        addressMap: this.state.addressMap,

                        position: JSON.stringify({
                            lat: global._regionFeature ? global._regionFeature.latitude : this.state.lat,
                            long: global._regionFeature ? global._regionFeature.longitude : this.state.long,
                        })
                    })
            :
            // Platform.OS === 'android' ?
            //     Tools.GoLinkMap(global._regionFeature ? global._regionFeature.latitude : this.state.lat,global._regionFeature ? global._regionFeature.longitude : this.state.long)
            //   //  Tools.GoLink(`geo:${global._regionFeature ? global._regionFeature.latitude : this.state.lat},${global._regionFeature ? global._regionFeature.longitude : this.state.long}`)
            //     :


            this.setState({
                /*   lat: this.state.regionFeature ? this.state.regionFeature.geometry.coordinates[1] : this.state.lat,
                   long: this.state.regionFeature ? this.state.regionFeature.geometry.coordinates[0] : this.state.long, */

                lat: global._regionFeature ? global._regionFeature.latitude : this.state.lat,
                long: global._regionFeature ? global._regionFeature.longitude : this.state.long,
                isVisible: true
            })
    }

    hiddenModal() {
        container.setState({
                visibleModal: ''
            },
            () => {
            })
    }


    goScreen(type, item, position) {
        container.setState({
                isLoading: false,
                lat: position.coords.latitude,
                long: position.coords.longitude
            },
            () => {
                //   if (Platform.OS !== "web")

                container.onFlyToPress(position.coords.longitude, position.coords.latitude)
                // const camera = await this.map.mapRef.current.getCamera();
                //
                // camera.zoom = 17;
                // camera.center.latitude = position.coords.latitude;
                // camera.center.longitude = position.coords.longitude;
                // this.map.mapRef.current.animateCamera(camera, {duration: 2000});
            }
        )

    }

    stateError() {
        container.setState({
            locationEnabled: false,
            isLoading: false,
        }, () => {
            // HMAlert(
            //     i18n.t('constant.message'),
            //     i18n.t('constant.retry'),
            //     [
            //         // {text: 'Ask me later', onPress: () => {}},
            //         {
            //             text: i18n.t('constant.ok'), onPress: () => {
            //                 NavigationService.BackTo(1)
            //                 //  NavigationService.navigatereset("ApplyScreen", {item: item})
            //             }
            //             //  NavigationService.navigatereset("ApplyScreen",{item: item})
            //
            //             , style: 'cancel'
            //         },
            //
            //     ],
            //     {cancelable: false}
            // )
        })
    }
}

export default ShowMap;
